import { useState } from 'react';
import { supabase } from '../lib/supabase';

type Status =
  | { kind: 'idle' }
  | { kind: 'loading' }
  | { kind: 'success'; message: string }
  | { kind: 'error'; message: string };

export default function PublishStagingButton() {
  const [status, setStatus] = useState<Status>({ kind: 'idle' });

  const handleClick = async () => {
    if (status.kind === 'loading') return;
    const ok = window.confirm(
      'Triển khai nội dung hiện tại lên môi trường staging?\n(staging.vietparenting.com)',
    );
    if (!ok) return;

    setStatus({ kind: 'loading' });
    const { data, error } = await supabase.functions.invoke<{
      ok?: boolean;
      message?: string;
      error?: string;
    }>('publish-staging', { body: {} });

    if (error) {
      setStatus({ kind: 'error', message: error.message });
      return;
    }
    if (data?.ok) {
      setStatus({
        kind: 'success',
        message: data.message ?? 'Đã kích hoạt triển khai staging.',
      });
      return;
    }
    setStatus({
      kind: 'error',
      message: data?.error ?? 'Triển khai thất bại. Vui lòng thử lại.',
    });
  };

  const label =
    status.kind === 'loading' ? 'Đang triển khai…' : 'Triển khai lên Staging';

  return (
    <div className="flex items-center gap-3">
      {status.kind === 'success' && (
        <span className="text-xs text-emerald-700">✓ {status.message}</span>
      )}
      {status.kind === 'error' && (
        <span className="text-xs text-red-700">⚠ {status.message}</span>
      )}
      <button
        type="button"
        onClick={handleClick}
        disabled={status.kind === 'loading'}
        className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full text-sm font-semibold bg-red-600 text-white hover:bg-red-700 disabled:bg-red-300 disabled:cursor-not-allowed transition-colors"
      >
        <span aria-hidden>🚀</span>
        {label}
      </button>
    </div>
  );
}
